<mat-form-field appearance="outline">
  <mat-label>{{ label ?? name }}</mat-label>
  <input
    matInput
    [formControl]="inputControl"
    [placeholder]="placeholder ?? label ?? name"
    [matAutocomplete]="autocompleteCompany"
    [errorStateMatcher]="matcher"
    />
    <mat-autocomplete #autocompleteCompany="matAutocomplete" [displayWith]="displayValueFn">
      @for (item of datasource; track item) {
        <mat-option [value]="item"> {{ item.Name }} </mat-option>
      }
    </mat-autocomplete>
    @if (description) {
      <mat-hint>
        <mat-icon>info</mat-icon>
        {{ description }}
      </mat-hint>
    }
  </mat-form-field>
